(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./more.less", "../inline-loading"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./more.less"), require("../inline-loading"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.more, global.inlineLoading);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _more, _inlineLoading) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _inlineLoading = _interopRequireDefault(_inlineLoading);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-scroll-view-more"
      }, [!_vm.isFinished ? [_c('nx-inline-loading', {
        attrs: {
          "type": "roller"
        }
      }), _vm._v("\n    " + _vm._s(_vm.loadingText) + "\n  ")] : [_vm._v("\n    " + _vm._s(_vm.finishedText) + "\n  ")]], 2);
    },
    name: 'nx-scroll-view-more',
    components: (0, _defineProperty2.default)({}, _inlineLoading.default.name, _inlineLoading.default),
    props: {
      loadingText: {
        type: String,
        default: '更多加载中...'
      },
      finishedText: {
        type: String,
        default: '全部已加载'
      },
      isFinished: {
        type: Boolean,
        default: false
      }
    }
  };
  _exports.default = _default;
});